
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/academy",
      function () {
        return require("private-next-pages/resources/academy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/academy"])
      });
    }
  